import { Pipe, PipeTransform } from '@angular/core';
import { TransportKind } from '@/common/enums/TransportKind';

@Pipe({
	name: 'transportKindIcon',
})
export class TransportKindIconPipe implements PipeTransform {
	transform(value: unknown): string {
		const code = typeof value === 'string' ? value : (value as TransportKind | null | undefined);

		if (!code) {
			return '';
		}

		switch (code) {
			case TransportKind.COACH:
				return 'fa-bus';
			case TransportKind.FLIGHT:
				return 'fa-plane';
			case TransportKind.WITHOUT:
				return 'fa-ban';
			case TransportKind.MIX:
				return 'fa-right-left';
			default:
				return '';
		}
	}
}
